import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Injectable, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PermissionDefinitionDto } from '@app/apiModules/permissionDefinitionDto';
import { RoleDto } from '@app/apiModules/roleDtoPagedResultDto';
import { ConstantsService } from '@app/common/constants.service';
import { RolesManagementMainComponent } from '@app/modules/administrator/roles-management-main/roles-management-main.component';
import { AlertService } from '@app/shared/services/alert.service';
import { CommonService } from '@app/shared/services/CommonService';
import { EventEmitterService } from '@app/shared/services/eventemitter.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { PermissionService } from '@app/shared/services/PermissionService';
import { RoleService } from '@app/shared/services/role.service';
import { isNil } from 'lodash';
import { ripple, textField, formField } from 'material-components-web';
import { firstValueFrom } from 'rxjs';

import { ToastrService } from 'ngx-toastr';
import {
  TreeviewItem, TreeviewConfig,
  TreeviewEventParser, OrderDownlineTreeviewEventParser, DownlineTreeviewItem,
  TreeviewModule
} from 'ngx-treeview-v2';
import { TreeviewComponent } from '@app/shared/shared-components/treeview/treeview.component';
import { CommonModule } from '@angular/common';

@Injectable()
export class RoleTreeviewConfig extends TreeviewConfig {
  hasAllCheckBox = true;
  hasFilter = true;
  hasCollapseExpand = false;
  maxHeight = 2000;
}
@Component({
  standalone: true,
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrl: './add-role.component.scss',
  providers: [
    { provide: TreeviewEventParser, useClass: OrderDownlineTreeviewEventParser },
    { provide: TreeviewConfig, useClass: RoleTreeviewConfig }
  ],
  imports: [TreeviewModule, FormsModule, ReactiveFormsModule , TreeviewComponent, CommonModule]
})
export class AddRoleComponent implements OnInit, OnChanges, AfterViewInit {
  roleForm: UntypedFormGroup;
  isActive: boolean = false;
  @Input() public data: RoleDto;

  @Input() public defaultPermissions: PermissionDefinitionDto[];
  @Input() public casePlaceholder: any;
  @Output("closeSlider") closeSlider: EventEmitter<any> = new EventEmitter();
  @Output() selectedChange = new EventEmitter<any>();
  @ViewChild('submitButton') submitButton: ElementRef;
  isHost: boolean = false;
  submitted = false;
  selectedPermissions: any;
  config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 2000,
  });
  hasAllVisibility: boolean;
  filterText: 'Filter';
  rows: string[];
  buttonClasses = [
    'btn-outline-primary',
    'btn-outline-secondary',
    'btn-outline-success',
    'btn-outline-danger',
    'btn-outline-warning',
    'btn-outline-info',
    'btn-outline-light',
    'btn-outline-dark'
  ];
  buttonClass = this.buttonClasses[0];
  sections: TreeviewItem[];
  tenantName: string = "Host";
  permissionApiResponse;
  convertedPermission;
  setup: any;
  permissions: PermissionDefinitionDto[];
  treeitems: TreeviewItem[] = [];
  items: TreeviewItem[] = [];
  loading: boolean;
    isAdminRoles = false;
  get f() { return this.roleForm.controls; }
  constructor(
    public roleService: RoleService,
    public roleComponent: RolesManagementMainComponent,
    public alertService: AlertService, // Service for managing alerts
    public loader: LoaderService,
    private eventService: EventEmitterService,
    public formBuilder: UntypedFormBuilder,
    private permissionService: PermissionService,
    private readonly loaderService: LoaderService,
    public toastr: ToastrService,
    public cdr: ChangeDetectorRef) {
  }
  ngOnInit() {
    this.roleForm = this.formBuilder.group({
      name: [null, Validators.required],
      isPublic: [false],
      isDefault: [false],
      isStatic: [false],
      isAdmin: [false],
      concurrencyStamp: [null],
      description: [null],
      isActive: [false],
      permission: [this.defaultPermissions]
    });
    this.closeEvent();
  }
  IsNullOrEmpty(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return false;
  }
  /* istanbul ignore next */
  initMatComponent() {
    [].forEach.call(document.querySelectorAll('.text-material'), function (element) {
      if (element && element.querySelector('.mdc-text-field__input')) {
        textField.MDCTextField.attachTo(element);
      }
    });

    [].map.call(document.querySelectorAll('.ripple-material'), function (el) {
      ripple.MDCRipple.attachTo(el);
    });
  }
  /* istanbul ignore next */
  ngAfterViewInit() {
    setTimeout(() => {
      [].forEach.call(document.querySelectorAll('.text-material'), function (element) {
        if (element && element.querySelector('.mdc-text-field__input')) {
          textField.MDCTextField.attachTo(element);
        }
      });
      [].forEach.call(document.querySelectorAll('.ripple-material'), function (el) {
        if (el) {
          ripple.MDCRipple.attachTo(el);
        }
      });
      [].forEach.call(document.querySelectorAll('.formfield-material'), function (elem) {
        if (elem) {
          formField.MDCFormField.attachTo(elem);
        }
      });
    }, 2000);
  }
  on_paste_omit_special_char(event: ClipboardEvent, control) {
    let clipboardData = event.clipboardData;
    let filteredText = '';
    let pastedText = clipboardData.getData('text');
    let k;
    for (let i = 0; i < pastedText.length; i++) {
      k = pastedText.charCodeAt(i);
      if ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)) {
        filteredText += pastedText.charAt(i)
      }
    }
    this.roleForm.controls[control].setValue(filteredText);
    return false;
  }

  omit_special_char(event) {
    let k;
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  onCheckChange(isActive) {
    if (isActive) {
      this.roleForm.controls['isActive'].setValue(true)
    } else {
      this.roleForm.controls['isActive'].setValue(false)
    }
  }
  close() {
    this.submitted = false;
    this.roleForm.reset();
    this.closeSlider.emit();
  }
  closeEvent() {
    this.eventService.events$.forEach(_event => {

      this.close();
    });
  }
  save() {
    this.submitted = true;
    this.roleForm.value.isActive = this.roleForm.controls['isActive'].value;
    this.submitButton.nativeElement.disabled = true;
    // Check for invalid combination of permissions
    if (
      this.selectedPermissions &&
      this.selectedPermissions.includes('MANAGE.RELEASE.MODIFY') &&
      this.selectedPermissions.includes('MANAGE.RELEASE.STATUS.VIEW')
    ) {
      this.toastr.error(
      'You cannot select "Modify Release" and "View Release" permissions at the same time in Manage Releases Section.',
      'Invalid Permission Selection'
      );
      this.submitButton.nativeElement.disabled = false;
      return;
    }
    if (!this.selectedPermissions || this.selectedPermissions.length === 0) {
    this.toastr.error('Please select at least one permission', 'Error');
    this.submitButton.nativeElement.disabled = false;
    return;
    }
    let updatedPermissions = this.updatePermissions(this.defaultPermissions, this.selectedPermissions);
    this.roleForm.controls['permission'].setValue(updatedPermissions);
    if (this.roleForm.invalid) {
      return;
    }
    // If data is present, update the role
    if (this.data) {
      this.roleService.apiAppRoleIdPut(this.data.id, this.roleForm.getRawValue())
        .subscribe({
          next:
            (_response) => {
              let toastMsg = "";
              toastMsg = "Role updated successfully";
              this.toastr.success(toastMsg, "");
              // this.sendNotification(this.roleForm.value);
              this.close();
              this.roleComponent.ngOnInit();
            },
          error: (error) => { //Error callback

            if (error.error.error.code === "601") {
              this.alertService.buildDialog().fire({
                title: "ERROR!",
                text: "Role already exists",
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: "OK",
                cancelButtonText: "",
              });
            }
            else if (error.error.error.code === "604") {
              this.alertService.buildDialog().fire("ERROR!", "Error While adding Permission", "error");
            }
            else {
              this.alertService.buildDialog().fire({
                title: "ERROR!",
                text: error.error.error.message,
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: "OK",
                cancelButtonText: "",
              });
            }
            this.close();
          }
        });
         this.initMatComponent();
    } else {
      this.roleForm.controls['isPublic'].setValue(false);
      this.roleForm.controls['isStatic'].setValue(false);
      this.roleForm.controls['isDefault'].setValue(false);
      this.roleForm.controls['isAdmin'].setValue(false);

      if (this.roleForm.value.isActive == null) {
        this.roleForm.controls['isActive'].setValue(false);
      }
      this.roleService.apiAppRolePost(this.roleForm.value)
        .subscribe({
          next:
            (_response) => {
              let toastMsg = "";
              toastMsg = "Role created successfully";
              this.toastr.success(toastMsg, "");

              // this.sendNotification(this.roleForm.value);
              this.close();
              this.roleComponent.ngOnInit();
            },
          error: (error) => { //Error callback
            if (error.error.error.code === "601") {
              this.alertService.buildDialog().fire({
                title: "ERROR!",
                text: "Role already exists",
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: "OK",
                cancelButtonText: "",
              });
            }
            else if (error.error.error.code === "604") {
              this.alertService.buildDialog().fire("ERROR!", "Permission Denied", "error");
            }
            else {
              this.alertService.buildDialog().fire({
                title: "ERROR!",
                text: error.error.error.message,
                icon: this.alertService.ErrorIcon,
                showCancelButton: false,
                confirmButtonText: "OK",
                cancelButtonText: "",
              });
            }
            this.close();
          }
        });
    }
  }
  //TreeView Data
  convert(array) {
    let map = {};
    for (let obj of array) {
      obj.children = [];

      map[obj.name] = obj;

      let parent = obj.parentName || '-';

      if (!map[parent]) {
        map[parent] = {
          children: []
        };
      }
      map[parent].children.push(obj);
    }
    if (map['-'].children != undefined)
      return map['-'].children;
    else
      return [];
  }
  setLoader() {
    this.loading = true;
    this.loaderService.showSpinner.next(true);
  }
  setUnLoader() {
    this.loading = false;
    this.loaderService.showSpinner.next(false);
  }
  ngOnChanges(_changes: SimpleChanges) {
    this.items = [];
    if (this.data) {
      this.setLoader();
      setTimeout(() => {
        firstValueFrom(this.roleService.apiAppRoleIdGet(this.data.id)).then((res) => {
          if (res && res.id) {
            this.isAdminRoles = res.isAdmin;
            this.roleForm = this.formBuilder.group({
              concurrencyStamp: [res.concurrencyStamp],
              id: [res.id],
              name: [res.name, Validators.required],
              isPublic: [res.isPublic],
              isDefault: [res.isDefault],
              isStatic: [res.isStatic],
              isAdmin: [res.isAdmin],
              description: [res.description],
              isActive: [res.isActive],
              permission: [res.permission]
            });
          }

          if (res.isAdmin) {
            this.roleForm.get('name')?.disable();
          }

          this.isActive = res.isActive;
          if (res.permission) {
            this.getPermissions(res.permission);
          }
          this.setUnLoader();

        });

      }, 1000);
    }
    else {
      if (this.defaultPermissions.length > 0) {
        this.resetIsGranted(this.defaultPermissions);
        this.getPermissions(this.defaultPermissions);
      }
    }

  }

  getPermissions(permissions) {
    this.items = this.getItems(permissions);

    if (!this.items || this.items.length === 0) {
      throw new Error("Treeview items became undefined or empty!");
    }
  }

    updatePermissions(features: any[], permissions: string[]): any[] {
      const updateRecursive = (nodes: any[]) => {
        nodes.forEach(node => {
          node.isGranted = permissions.includes(node.name);
          if (node.children && node.children.length > 0) {
            updateRecursive(node.children);
          }
        });
      };
      updateRecursive(features);
      return features;
    }
    selectPermissionItem(downlineItems: DownlineTreeviewItem[]) {
    this.selectedPermissions = [];

    downlineItems.forEach(downlineItem => {
      // Add all checked ancestors (parents, grandparents, etc.)
      let parent = downlineItem.parent;
      while (parent && parent.item) {
        const parentValue = parent.item.value;
        if (parent.item.checked && parentValue && !this.selectedPermissions.includes(parentValue)) {
          this.selectedPermissions.push(parentValue);
        }
        parent = parent.parent;
      }

      // Add current item if checked
      const item = downlineItem.item;
      const value = item.value;
      if (item.checked && value && !this.selectedPermissions.includes(value)) {
        this.selectedPermissions.push(value);
      }
    });
  }

  onFilterChange(_value: string) {
    //Intentional
  }

  noop() { } // no-operation empty event 

  onCheckedChangePopup(item: any) {
    const parent = item.parent;

    if (( item.value === 'MANAGE.RELEASE.MODIFY') && item.checked) {
      // Disable "MANAGE.RELEASE.STATUS.VIEW" sibling
      if (parent && parent.children) {
        const viewNode = parent.children.find(child => child.value === 'MANAGE.RELEASE.STATUS.VIEW');
        if (viewNode) {
          viewNode.internalDisabled = true;
          viewNode.internalChecked = false;
        }
      }
    } else if (( item.value === 'MANAGE.RELEASE.MODIFY') && !item.checked) {
      // Enable "MANAGE.RELEASE.STATUS.VIEW" sibling if this is unchecked
      if (parent && parent.children) {
        const viewNode = parent.children.find(child => child.value === 'MANAGE.RELEASE.STATUS.VIEW');
        if (viewNode) {
          viewNode.internalDisabled = false;
        }
      }
    }

    if (item.value === 'MANAGE.RELEASE.STATUS.VIEW' && item.checked) {
      if (parent && parent.children) {
        parent.children.forEach(child => {
          if (child.value === 'MANAGE.RELEASE.MODIFY') {
            child.internalDisabled = true;
            child.internalChecked = false;
          }
        });
      }
    } else if (item.value === 'MANAGE.RELEASE.STATUS.VIEW' && !item.checked) {
      if (parent && parent.children) {
        parent.children.forEach(child => {
          if (child.value === 'MANAGE.RELEASE.MODIFY') {
            child.internalDisabled = false;
          }
        });
      }
    }
    this.cdr.detectChanges();
  }
  getItems(permissionData): TreeviewItem[] {
    if (!permissionData || !Array.isArray(permissionData)) return [];

    // Pass null as parent for root nodes
    return permissionData.map(permission => this.createTreeviewItem(permission, null));
  }
  createTreeviewItem(permission, parent): TreeviewItem {
    const hasChildren = permission.children && Array.isArray(permission.children) && permission.children.length > 0;
    const item = new TreeviewItem({
      text: permission.displayName,
      value: permission.name,
      collapsed: true,
      checked: permission.isGranted,
      children: undefined // will be set below if needed
    });

    // Assign parent reference
    (item as any).parent = parent;

    // Disable "View Audit Logs" by default
    // if (permission.name === 'MANAGE.RELEASE.AUDIT.VIEW') {
    //   (item as any).internalDisabled = true;
    // }
    
    // Recursively create children and assign parent
    if (hasChildren) {
      item.children = permission.children.map(child =>
        this.createTreeviewItem(child, item)
      );
    }

    return item;
  }
  mapChildren(children, parent?): TreeviewItem[] {
    if (!children || !Array.isArray(children)) return [];
    return children.map(child => this.createTreeviewItem(child, parent));
  }
  resetIsGranted(permissions: any[]) {
  permissions.forEach(p => {
    p.isGranted = false;
    if (p.children && p.children.length > 0) {
      this.resetIsGranted(p.children);
    }
  });
 }
 
} 
